import clsx from "clsx"

import useHeightCSSVariable from "@hooks/useHeightCSSVariable"

import styles from "./DrawerDragIndicator.module.scss"

export interface DrawerDragIndicatorProps {
    className?: string
}

export default function DrawerDragIndicator(props: DrawerDragIndicatorProps) {
    const { className } = props

    const dragIndicatorRef = useHeightCSSVariable<HTMLDivElement>("--popover-drag-indicator-height")

    return (
        <div ref={dragIndicatorRef} className={clsx(styles.base, className)}>
            <span className={styles.indicator} />
        </div>
    )
}
